import React, { useRef } from "react";
import "./Modal.css";
import useLockBodyScroll from "@/helpers/useLockBodyScroll";
import closeIcon from "@/assets/svgs/Account/closeIcon.svg";
import Image from "next/image";
import ButtonAnimated from "../ButtonAnimated/ButtonAnimated";
import useIsMobile from "@/app/helpers/useIsMobile";

function Modal({
  isVisible,
  label,
  children,
  onClose,
  footerButton = false,
  footerButtonFunction = () => {},
  footerButtonDisabled = false,
  removeHeader,
  imageLeft = undefined,
  maxWidth = "512px",
  removePadding = false,
  fileReader = undefined,
}) {
  const modalRef = useRef(null);

  // Lock body scroll when the modal is visible
  useLockBodyScroll(isVisible);

  const isMobile = useIsMobile();

  if (!isVisible) {
    return null; // Don't render anything if isVisible is false
  }

  return (
    <div className="Modal">
      <div className="Modal-backdrop" onClick={onClose}></div>
      <div
        className="Modal-content"
        style={{
          paddingBottom: footerButton && "0px !important",
          maxWidth: maxWidth,
        }}
        ref={modalRef}
      >
        {imageLeft && !isMobile && (
          <Image
            src={imageLeft}
            className="Modal-left-image"
            alt="Popup image"
          />
        )}

        <div
          className="Modal-content-wrapper"
          style={{ padding: removePadding ? "0px" : "48px 24px" }}
        >
          <div className="Modal-close-wrapper transition" onClick={onClose}>
            <Image
              src={closeIcon}
              className="Modal-close-icon"
              alt="Modal close icon"
            />
          </div>

          {!removeHeader && (
            <div className="Modal-header">
              <span className="Modal-title">{label}</span>
            </div>
          )}

          <div className="Modal-body">{children}</div>
          {footerButton && (
            <div className="Modal-footer">
              <ButtonAnimated
                hideMaxWidth
                disabled={footerButtonDisabled}
                width="100%"
                height="48px"
                fontSize="16px"
                text={footerButton}
                onClick={footerButtonFunction}
              />
              {fileReader && fileReader}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;
